var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container mh-lg-100-vh" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        {
          staticClass:
            "col-12 col-lg-5 col-xl-6 data-fixed-side d-none d-lg-block"
        },
        [
          _c("h2", {
            staticClass: "mb-40",
            domProps: { innerHTML: _vm._s(_vm.copyConfig.order_form.title) }
          }),
          _vm._v(" "),
          _c("el-orders", {
            staticClass: "mr-xl-24",
            model: {
              value: _vm.abstractOrders,
              callback: function($$v) {
                _vm.abstractOrders = $$v
              },
              expression: "abstractOrders"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-12 col-lg-7 col-xl-6" },
        [
          _c("el-orders-form", {
            staticClass: "ml-xl-24 p-0 p-lg-40 mb-40",
            attrs: { orders: _vm.orders, "copy-config": _vm.copyConfig }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }